import moment from "moment"

export const formatDate = (date) => {
    return moment(date).format('DD-MM-YYYY hh:mm A')
}

export const generateYearsList = (startYear = 2022) => {
    const currentYear = new Date().getFullYear();
    const yearsList = [];

    for (let year = currentYear; year >= startYear; year--) {
        yearsList.push({
            value: year,
            label: year.toString(),
        });
    }
    return yearsList;
}

export const formatString = (input) => {
    if (typeof input !== "string") {
        throw new Error("Input must be a string");
    }

    return input
        .replace(/_/g, " ")
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
}

export function setFavicon(url) {
    const link = document.querySelector("link[rel~='icon']") || document.createElement("link");
    link.rel = 'icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
}

export const getImageBase64FromUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // Base64 string
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export const statusColors = [
    {
        status: "PENDING",
        color: "#FFA500", // Orange for pending
    },
    {
        status: "APPROVED",
        color: "#4CAF50", // Green for approved
    },
    {
        status: "REJECTED",
        color: "#F44336",   //Red
    },
    {
        status: "RETURNED",
        color: "#F44336", //Red
    },
    {
        status: "DELIVERED",
        color: "#4CAF50", // Green for approved
    },
    {
        status: "COMPLETED",
        color: "#4CAF50", // Green for approved
    },
    {
        status: "INITIATED",
        color: "#FFA500", // Orange for pending
    },
    {
        status: "DISPATCHED",
        color: "#6f42c1", // Orange for pending
    },
    {
       status: "CANCELLED",
       color: "#ff6900", // Orange for pending
    },
];


export const StatusLabel = ({ status }) => {
    // Find the color for the given status
    const statusColor = statusColors.find(item => item.status === status)?.color || "#000"; // Default to black if status not found

    return (
        <span className="flex justify-center items-center"
            style={{
                backgroundColor: statusColor,
                color: "#fff", // White text for better contrast
                padding: "5px 10px",
                borderRadius: "5px",
                fontSize: "12px",
                fontWeight: "bold",
            }}
        >
            {status}
        </span>
    );
};

